import { useMemo } from 'react';

import { orderStage, orderSecondaryStage } from 'common/constants/booking';
import { DEFAULT_COMPLETE_DUE_HOURS } from '~constants/payment';

const useDueHours = ({
  stage,
  secondaryStage,
  confirmationDuration,
  paymentDuration,
  counterOfferPeriodDurations,
}) => {
  const dueHours = useMemo(() => {
    if (stage === orderStage.WAITING_FOR_CONFIRMATION) {
      if (secondaryStage === orderSecondaryStage.PENDING_COUNTER_OFFER) {
        return counterOfferPeriodDurations;
      }

      return confirmationDuration;
    }

    if (stage === orderStage.WAITING_FOR_PAYMENT) {
      return paymentDuration;
    }

    return DEFAULT_COMPLETE_DUE_HOURS;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stage, confirmationDuration, paymentDuration]);

  return {
    dueHours,
  };
};

export default useDueHours;
